import axios from 'axios';

const axiosInstance = axios.create({
  // Relative baseURL keeps dev/prod host aligned and avoids localhost leakage in deployments.
  baseURL: '/',
  withCredentials: true,
});

export default axiosInstance;